import { useGridLoggerFactory } from "./useGridLoggerFactory.es.js";
import { useGridApiInitialization } from "./useGridApiInitialization.es.js";
import { useGridLocaleText } from "./useGridLocaleText.es.js";
import { useGridStateInitialization } from "./useGridStateInitialization.es.js";
import { useGridPipeProcessing } from "./pipeProcessing/useGridPipeProcessing.es.js";
import { useGridStrategyProcessing } from "./strategyProcessing/useGridStrategyProcessing.es.js";
const useGridInitialization = (inputApiRef, props) => {
  const privateApiRef = useGridApiInitialization(inputApiRef, props);
  useGridLoggerFactory(privateApiRef, props);
  useGridStateInitialization(privateApiRef, props);
  useGridPipeProcessing(privateApiRef);
  useGridStrategyProcessing(privateApiRef);
  useGridLocaleText(privateApiRef, props);
  privateApiRef.current.register("private", {
    rootProps: props
  });
  return privateApiRef;
};
export {
  useGridInitialization
};
//# sourceMappingURL=useGridInitialization.es.js.map
